export default __webpack_public_path__ + "static/media/helidon.ef111c9e.svg";